import { useChainId, useBalance } from 'wagmi'
import { NetworkId } from '@/types/network'
import { getPepperTreasuryBalanceAddress } from '@/config/get-pepper-treasury-address'

export function usePepperTreasuryEthBalance() {
	const chainId = useChainId()

	const treasuryAddress = getPepperTreasuryBalanceAddress(chainId as NetworkId)

	return useBalance({
		address: treasuryAddress
	})
}
